var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "shared/api/axios-instance";
import { PAYMENT_METHODS } from "../model/types/auction.types";
var STATUS_MAP = {
    PENDING: "scheduled",
    ACTIVE: "live",
    FINALIZED: "finalized",
    CANCELLED: "cancelled",
};
var BID_STATUS_MAP = {
    ACTIVE: "active",
    WON: "won",
    REFUNDED: "refunded",
    CANCELLED: "lost",
};
var normalizePaymentMethod = function (symbol) {
    var upper = symbol === null || symbol === void 0 ? void 0 : symbol.toUpperCase();
    return PAYMENT_METHODS.includes(upper)
        ? upper
        : "QUANTA";
};
var toAdminAuction = function (a) {
    var _a;
    return ({
        id: a.id,
        collectionId: a.collectionId,
        description: "",
        settlementModel: "highest-first-time-priority",
        rules: [],
        minBidUsd: a.minimumBid,
        publicSalePriceUsd: a.publicSalePrice,
        totalSupply: a.auctionSupply,
        allocationPerBidderMax: 1,
        startsAt: a.startDate,
        endsAt: a.endDate,
        paymentMethods: [],
        // Бэкенд имеет единый терминальный статус FINALIZED (отдельного «ended» нет):
        // аукцион после endDate авто-финализируется кроном или вручную из админки.
        status: (_a = STATUS_MAP[a.status]) !== null && _a !== void 0 ? _a : "finalized",
        finalizedAt: a.status === "FINALIZED" ? a.endDate : null,
        cancelledAt: a.status === "CANCELLED" ? a.endDate : null,
        createdAt: a.startDate,
        updatedAt: a.startDate,
    });
};
var toAdminBid = function (b) {
    var _a, _b;
    return ({
        id: b.id,
        auctionId: b.auctionId,
        collectionId: b.collectionId,
        userId: b.userId,
        username: (_a = b.username) !== null && _a !== void 0 ? _a : "",
        walletAddress: "",
        bidAmountUsd: b.totalPrice,
        token: b.paymentMethod,
        paymentMethod: normalizePaymentMethod(b.paymentMethod),
        status: (_b = BID_STATUS_MAP[b.status]) !== null && _b !== void 0 ? _b : "active",
        allocatedTokens: b.allocatedTokens,
        createdAt: b.createdAt,
    });
};
var fetchAll = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/admin/auctions", { params: { limit: 100 } })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data.data.map(toAdminAuction)];
        }
    });
}); };
var resolveCollectionId = function (auctionId) { return __awaiter(void 0, void 0, Promise, function () {
    var all, found;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAll()];
            case 1:
                all = _a.sent();
                found = all.find(function (a) { return a.id === auctionId; });
                if (!found)
                    throw new Error("Auction \"".concat(auctionId, "\" not found"));
                return [2 /*return*/, found.collectionId];
        }
    });
}); };
var resolveBidCoinId = function (methods) { return __awaiter(void 0, void 0, Promise, function () {
    var symbol, data, coin;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                symbol = (_a = methods[0]) !== null && _a !== void 0 ? _a : "QUANTA";
                return [4 /*yield*/, api.get("/coin/all")];
            case 1:
                data = (_b.sent()).data;
                coin = data.find(function (c) { var _a; return ((_a = c.symbol) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === symbol.toUpperCase(); });
                if (!coin) {
                    throw new Error("Coin \"".concat(symbol, "\" not found \u2014 cannot set auction bid token"));
                }
                return [2 /*return*/, coin.id];
        }
    });
}); };
var toIso = function (value) {
    var date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toISOString();
};
export var auctionsAdminApi = {
    list: function () { return __awaiter(void 0, void 0, Promise, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchAll()];
    }); }); },
    listByCollection: function (collectionId) { return __awaiter(void 0, void 0, Promise, function () {
        var all;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchAll()];
                case 1:
                    all = _a.sent();
                    return [2 /*return*/, all.filter(function (a) { return a.collectionId === collectionId; })];
            }
        });
    }); },
    get: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var all, found;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchAll()];
                case 1:
                    all = _a.sent();
                    found = all.find(function (a) { return a.id === id; });
                    if (!found)
                        throw new Error("Auction \"".concat(id, "\" not found"));
                    return [2 /*return*/, found];
            }
        });
    }); },
    create: function (collectionId, data) { return __awaiter(void 0, void 0, Promise, function () {
        var bidCoinId, _a, all, created;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_b = data.bidCoinId) !== null && _b !== void 0)) return [3 /*break*/, 1];
                    _a = _b;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, resolveBidCoinId(data.paymentMethods)];
                case 2:
                    _a = (_c.sent());
                    _c.label = 3;
                case 3:
                    bidCoinId = _a;
                    return [4 /*yield*/, api.post("/admin/collections/".concat(collectionId, "/auction"), {
                            startDate: toIso(data.startsAt),
                            endDate: toIso(data.endsAt),
                            minimumBid: data.minBidUsd,
                            publicSalePrice: data.publicSalePriceUsd,
                            auctionSupply: Number(data.totalSupply) || 1,
                            bidCoinId: bidCoinId,
                        })];
                case 4:
                    _c.sent();
                    return [4 /*yield*/, fetchAll()];
                case 5:
                    all = _c.sent();
                    created = all.find(function (a) { return a.collectionId === collectionId; });
                    if (!created)
                        throw new Error("Auction created but not found in list");
                    return [2 /*return*/, created];
            }
        });
    }); },
    update: function (id, data) { return __awaiter(void 0, void 0, Promise, function () {
        var collectionId, bidCoinId, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, resolveCollectionId(id)];
                case 1:
                    collectionId = _c.sent();
                    if (!((_b = data.bidCoinId) !== null && _b !== void 0)) return [3 /*break*/, 2];
                    _a = _b;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, resolveBidCoinId(data.paymentMethods)];
                case 3:
                    _a = (_c.sent());
                    _c.label = 4;
                case 4:
                    bidCoinId = _a;
                    return [4 /*yield*/, api.patch("/admin/collections/".concat(collectionId, "/auction"), {
                            startDate: toIso(data.startsAt),
                            endDate: toIso(data.endsAt),
                            minimumBid: data.minBidUsd,
                            publicSalePrice: data.publicSalePriceUsd,
                            auctionSupply: Number(data.totalSupply) || 1,
                            bidCoinId: bidCoinId,
                        })];
                case 5:
                    _c.sent();
                    return [2 /*return*/, auctionsAdminApi.get(id)];
            }
        });
    }); },
    cancel: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var collectionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveCollectionId(id)];
                case 1:
                    collectionId = _a.sent();
                    return [4 /*yield*/, api.post("/admin/collections/".concat(collectionId, "/auction/cancel"))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, auctionsAdminApi.get(id)];
            }
        });
    }); },
    finalize: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var collectionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveCollectionId(id)];
                case 1:
                    collectionId = _a.sent();
                    return [4 /*yield*/, api.post("/admin/collections/".concat(collectionId, "/auction/finalize"))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, auctionsAdminApi.get(id)];
            }
        });
    }); },
    // Backend has no delete-auction endpoint (only cancel) — no-op.
    remove: function (_id) { return __awaiter(void 0, void 0, Promise, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    listBids: function (auctionId, filters) { return __awaiter(void 0, void 0, Promise, function () {
        var collectionId, data, bids, q_1, min_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveCollectionId(auctionId)];
                case 1:
                    collectionId = _a.sent();
                    return [4 /*yield*/, api.get("/admin/auctions/".concat(collectionId, "/bids"))];
                case 2:
                    data = (_a.sent()).data;
                    bids = data.data.map(toAdminBid);
                    if (filters === null || filters === void 0 ? void 0 : filters.status) {
                        bids = bids.filter(function (b) { return b.status === filters.status; });
                    }
                    if (filters === null || filters === void 0 ? void 0 : filters.paymentMethod) {
                        bids = bids.filter(function (b) { return b.paymentMethod === filters.paymentMethod; });
                    }
                    if (filters === null || filters === void 0 ? void 0 : filters.search) {
                        q_1 = filters.search.toLowerCase();
                        bids = bids.filter(function (b) {
                            return b.username.toLowerCase().includes(q_1) ||
                                b.walletAddress.toLowerCase().includes(q_1);
                        });
                    }
                    if (filters === null || filters === void 0 ? void 0 : filters.minAmount) {
                        min_1 = Number(filters.minAmount);
                        if (Number.isFinite(min_1)) {
                            bids = bids.filter(function (b) { return Number(b.bidAmountUsd) >= min_1; });
                        }
                    }
                    return [2 /*return*/, bids];
            }
        });
    }); },
    deleteBid: function (bidId) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/admin/auctions/bids/".concat(bidId))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
};
